module.exports = __webpack_public_path__ + "media/images/patient-checkin-nav-hover-e27cba077df6fbe228bcf22044b7ac95.svg";